app.service('deliveryLocation', function (console, loading, geolocation, deliveryShops, broker, combobox, scroll) {
	var $container, $self, $locations, $locationInputs, $onlyAvailable, $shopFilters, $list, $toggleHours;
	var deliveryShops, refreshCallback = false;
	var scrollOnSuccess = false;

	broker.on('BEFORE_PAGE_CHANGE', function () {
		scrollOnSuccess = false;
	});

	function findNearestLocations(position) {
		var params = deliveryShops.findNearParams(position);
		refresh(params);
	}
	function nearestItems() {
		geolocation.findPosition(function (position) {
			findNearestLocations(position);
		}, function () {
			console.log('Błąd lokalizacji')
		});
	}
	function showAvailabilty(checked) {
		if (checked) {
			$self.addClass('show-only-available');
		} else {
			$self.removeClass('show-only-available');
		}
	}
	function toogleAvailabilty() {
		showAvailabilty($onlyAvailable.prop('checked'));
	}
	function moreLocations() {
		console.log('WIĘCEJ LOKALIZACJI');
		$self.addClass('show-more-locations');
		$self.addClass('delivery-time-not-changeable');
		$self.removeClass('has-more-locations');
		$self.removeClass('show-only-selected');
		toogleAvailabilty();
	}
	function showOtherLocations() {
		$self.addClass('select-other-location');
	}
	function selectLocation($location) {
		$locations.removeClass('selected-location');
		$location.closest('.js-location').addClass('selected-location');

		deliveryShops.selectLocation({
			city: $location.data('city'),
			shop: $location.data('shop'),
			machine: $location.data('machine')
		});
		if ($location.data('confirm')) {
			$self.addClass('show-delivery-time-message');
			$deliveryConfirm.ignore(false);
		} else {
			$self.removeClass('show-delivery-time-message');
			$deliveryConfirm.ignore(true);
		}
		$self.addClass('show-only-selected');
		if ($locations.length > 1 && $locations.filter(':visible').length < $locations.length) { // dodatkowa weryfikacja czy jest więcej lokacji niż pokazane
			$self.addClass('has-more-locations');
		} else {
			$self.removeClass('has-more-locations');
		}
		$('.radio-group.validate-target', $self).removeClass('validate-error');
	}

	function refreshSuccess(html, options, orgParams) {
		if (html) {
			$container.html(html);
		}
		var params = {
			shopCode: false,
			cityCode: false,
			moreLocations: false,
			locations: false,
			lastLocation: false
		};
		init();
		if ($self.find('#more-locations').length) {
			params.moreLocations = true;
			$self.addClass('has-more-locations');
		}
		if ($locations.length) {
			params.locations = true;
			$self.addClass('has-locations');
		}
		if ($self.find('#last-order-location').length) {
			params.shopCode = $('#last-order-location').data('shop');
			params.cityCode = $('#last-order-location').data('city');
			params.lastLocation = true;
		}

		if ((!$self.find('#last-order-location').length && !$locations.filter('.selected-location').length && $('#shop-delivery').length) || (orgParams && orgParams.showList)) {
			// Przypadek gdy nie ma wybranego sklepu np. dla opcji taxfree wyłączonej w ostatnio wybranym sklepie
			$('#preview-order-steps .row-delivery-point').hide();
			$('#container').removeClass('hide-shops');
		}
		if (scrollOnSuccess && $self.length) {
			scroll.to({ $element: $self });
		}
		scrollOnSuccess = false;
		$container.removeClass('loading');
		if (options.taxfree && $('#short-delivery-address-data .js-show-shops').is(':visible')) {
			if ($('.taxfree-message-empty-shop-list', $self).length || !$('.radio-css.selected-location', $self).length) {
				$('#short-delivery-address-data .js-show-shops').click();							// to jest hak, gdy lista sklepów się odświeży i prezentowany jest komunikat to bloczek powinien być w wersji rozwiniętej. DeliveryLocation jest do głębszej zmiany, przeedytowany w "poc ajax"
			}
		}

		if (refreshCallback) {
			refreshCallback(params);
		}
		deliveryShops.refreshSuccess();
	}
	function refresh(params) {
		$container.addClass('loading');
		deliveryShops.refresh(params, refreshSuccess);
	}
	function selectCity(cityCode) {
		// $self.removeClass('show-delivery-time-message');
		// $deliveryConfirm.ignore(true);
		var params = deliveryShops.selectCityParams(cityCode);
		if (params) {
			refresh(params);
		}
	}

	function setElements() {
		$container = $('#shops-list');
		$list = $('.shops-list', $container);
		$self = $('#location-box', $container);
		$locations = $('.js-location', $self);
		$locationInputs = $('input', $locations);
		$deliveryConfirm = $('#delivery-confirm', $self);
		$onlyAvailable = $('#only-available', $self);
		$shopFilters = $('.js-shop-filter', $self);
		$toggleHours = $('.js-toggle-hours', $self);
		if ($('#delivery-banner').length) {
			if ($('.delivery-badge').length) {
				let $b = $('.delivery-badge').detach();
				$b.appendTo("#delivery-banner");
			} else {
				//$('#delivery-banner').remove();
			}
		}
	}
	function setEvents() {
		$('.js-more-locations-button').on('click', function () {
			moreLocations();
		});
		combobox.init()
		$('#city-select').on('change', function () {
			selectCity($(this).val());
		});
		$onlyAvailable.on('click', function () {
			toogleAvailabilty();
		});
		$('#find-near').on('click', function () {
			nearestItems();
		});
		$shopFilters.on('click', function () {
			const $this = $(this);
			const filter = $this.data('filter');
			if (filter === 'all') {
				moreLocations();
			}
			if (!$this.hasClass('active')) {
				$shopFilters.removeClass('active');
				$this.addClass('active');
				$list.toggleClass('show-all-shops', filter === 'all');
			}
		});
		$locationInputs.on('click', function () {
			selectLocation($(this));
		});
		$toggleHours.on('click', function (event) {
			$(this).closest('label').toggleClass('show-hours-details');
			event.preventDefault();
			event.stopPropagation();
		});
	}
	function init(option, callback) {
		setElements(option);
		setEvents();
		if (callback) {
			refreshCallback = callback;
		}
		if (option) {
			if (!$('#search-city').length) {
				refresh(option);
			}
		}
	}
	function show() {
		$('#container').addClass('edit-shop').removeClass('hide-shops');
		showOtherLocations();
		scroll.to({ $element: $('#shops-list') });
		scrollOnSuccess = true;			// docelowy scroll po załadowaniu sklepów będzie później
	}
	return {
		init,
		refresh,
		show
	};
});
